import { getSpotCommodity } from "@/_core/data/api_calls/spot_data/getSpotCommodity";
import { getSpotCurrency } from "@/_core/data/api_calls/spot_data/getSpotCurrency";

/**
 * Fetches spot market data for a given asset (commodity or currency).
 *
 * @param {object} _this - The context object containing state variables and methods.
 * @param {string} fieldName - The name of the field to update with the spot data.
 * @param {string} fieldUpdatedAtName - The name of the field storing the timestamp of the last update.
 * @param {string} fieldShowLoadingName - The name of the field that determines if a loading indicator should be shown.
 * @param {string} asset - Specifies whether to fetch data for a "commodity" or "currency" (default is "currency").
 * @param {string|null} strip - Defines whether to request the entire strip (for commodities only).
 * @param {boolean} isContract - Specifies if the commodity request is based on a contract.
 * @param {string|null} pk - The primary key identifier for the currency request.
 *
 * @returns {Promise} - Returns a promise resolving to the spot data for the requested asset.
 */
export function getSpotData(
  _this,
  fieldName,
  fieldUpdatedAtName,
  fieldShowLoadingName,
  asset = "currency",
  strip = null,
  isContract = false,
  pk = null,
) {
  // Fetch currency spot data if asset type is "currency"
  if (asset === "currency") {
    return getSpotCurrency(_this, pk);
  }
  // Fetch commodity spot data if asset type is "commodity"
  else if (asset === "commodity") {
    return getSpotCommodity(
      _this,
      fieldName,
      fieldUpdatedAtName,
      fieldShowLoadingName,
      strip,
      isContract,
    );
  }
}
